// extracted by mini-css-extract-plugin
module.exports = {"withNotification":"supportMenu_withNotification__SHL_3","notificationBadge":"supportMenu_notificationBadge__FWEx7","pulse":"supportMenu_pulse__56aHv"};